// Bridge that lets a legacy v1 page open the v2 message composer. v1 cannot
// import v2 modules, so the seam is a window global and only plain data +
// callbacks cross it - the same isolation mountPageHeader uses.
//
// Unlike the page header, the composer is modal and long-lived: a v1 re-render
// must never disturb an in-progress message. So this surface is imperative
// (open once, the v2 side owns the drawer until it closes) rather than a host
// element the v1 component mounts and unmounts as it renders.
//
// This module stays dependency-free on purpose: it is imported eagerly by the
// chrome entrypoint, and pulling the composer in here would put the drawer, the
// rich text editor and i18n into the chunk every legacy page loads. The real
// implementation is fetched on first open and cached for later opens.
let appModule = null;

const loadApp = () => {
  appModule ||= import("./compose/composeChromeApp");
  return appModule;
};

// opts: { student?: { idOrSlug }, guardianIds?: number[],
//         admissionParents?: { schoolYearId, steps: string[], processId?, label },
//         onClose?, onSent? }
// School, slug and viewed school year are read from the page's app-props by the
// v2 side, so callers pass only what is specific to the trigger.
function openComposeDrawer(opts) {
  loadApp().then((mod) => mod.open(opts));
}

// Namespaced merge so each chrome surface can attach its own helpers.
window.AeChrome = {
  ...(window.AeChrome || {}),
  openComposeDrawer,
};

// Same readiness signal the page header bridge uses: the chrome bundle can
// evaluate after a v1 page has already mounted. Note that more than one surface
// dispatches this, so a listener must check for the specific function it needs
// rather than assuming window.AeChrome is fully populated.
window.dispatchEvent(new Event("aechrome:ready"));
